// helper
import { styleGenerator } from '../../helper';
// constants
import {
    C_BG,
    C_BORDER,
    C_BRADIUS,
    C_MARGIN,
    C_PADDING,
    T_TYPO,
    T_MARGIN,
    Q_TYPO,
    Q_MARGIN,
    I_BG,
    I_BORDER,
    I_BRADIUS,
    I_PADDING,
    I_SIZE
} from './constants';
/**
 * Internal dependencies
 */
const { generateBorderStyles, generateResBoxStyles, generateBgStyles, generateRangeStyles, generateTypographyStyles, GlobalStyleHandler } =
    window.faqmateModules;

// Generate Dynamic Style
const DynamicStyle = props => {
    const { attributes, setAttributes } = props;
    const { uniqueId, titleColor, answerColor, iconColor, countColor } = attributes;

    // container
    const {
        desktopStyles: cDeskBorder,
        tabletStyles: cTabBorder,
        mobileStyles: cMobBorder
    } = generateBorderStyles({
        controlName: C_BORDER,
        attributes
    });

    const {
        boxDeskStyles: cDeskBRadius,
        boxTabStyles: cTabBRadius,
        boxMobStyles: cMobBRadius
    } = generateResBoxStyles({
        controlName: C_BRADIUS,
        attributes,
        propertyName: 'border-radius',
        forRadius: true
    });

    const {
        boxDeskStyles: cDeskPadding,
        boxTabStyles: cTabPadding,
        boxMobStyles: cMobPadding
    } = generateResBoxStyles({
        controlName: C_PADDING,
        attributes,
        propertyName: 'padding',
        forRadius: false
    });

    const {
        boxDeskStyles: cDeskMargin,
        boxTabStyles: cTabMargin,
        boxMobStyles: cMobMargin
    } = generateResBoxStyles({
        controlName: C_MARGIN,
        attributes,
        propertyName: 'margin',
        forRadius: false
    });

    const { bgStyle: cBg } = generateBgStyles({
        controlName: C_BG,
        attributes
    });
    // title
    const {
        desktopStyles: tDeskTypo,
        tabletStyles: tTabTypo,
        mobileStyles: tMobTypo
    } = generateTypographyStyles({
        controlName: T_TYPO,
        attributes
    });

    const {
        boxDeskStyles: tDeskMargin,
        boxTabStyles: tTabMargin,
        boxMobStyles: tMobMargin
    } = generateResBoxStyles({
        controlName: T_MARGIN,
        attributes,
        propertyName: 'margin',
        forRadius: false
    });
    const {
        desktopStyles: qDeskTypo,
        tabletStyles: qTabTypo,
        mobileStyles: qMobTypo
    } = generateTypographyStyles({
        controlName: Q_TYPO,
        attributes
    });

    const {
        boxDeskStyles: qDeskMargin,
        boxTabStyles: qTabMargin,
        boxMobStyles: qMobMargin
    } = generateResBoxStyles({
        controlName: Q_MARGIN,
        attributes,
        propertyName: 'margin',
        forRadius: false
    });
    const {
        deskStyle: iDeskWidth,
        tabStyle: iTabWidth,
        mobStyle: iMobWidth
    } = generateRangeStyles({
        controlName: I_SIZE,
        attributes,
        propertyName: 'width'
    });

    const {
        deskStyle: iDeskHeight,
        tabStyle: iTabHeight,
        mobStyle: iMobHeight
    } = generateRangeStyles({
        controlName: I_SIZE,
        attributes,
        propertyName: 'height'
    });

    const {
        desktopStyles: iDeskBorder,
        tabletStyles: iTabBorder,
        mobileStyles: iMobBorder,
        hoverColor: iHoverBorderColor
    } = generateBorderStyles({
        controlName: I_BORDER,
        attributes
    });

    const {
        boxDeskStyles: iDeskBRadius,
        boxTabStyles: iTabBRadius,
        boxMobStyles: iMobBRadius
    } = generateResBoxStyles({
        controlName: I_BRADIUS,
        attributes,
        propertyName: 'border-radius',
        forRadius: true
    });

    const {
        boxDeskStyles: iDeskPadding,
        boxTabStyles: iTabPadding,
        boxMobStyles: iMobPadding
    } = generateResBoxStyles({
        controlName: I_PADDING,
        attributes,
        propertyName: 'padding'
    });

    const { bgStyle: iBg } = generateBgStyles({
        controlName: I_BG,
        attributes
    });

    // Desktop Styles
    const deskStyles = `
        ${styleGenerator(`.${uniqueId}.wp-block-faqmate-faq .asfa__head`, [
            {
                v: cDeskBorder
            },
            {
                v: cDeskBRadius
            },
            {
                v: cDeskPadding
            },
            {
                v: cDeskMargin
            },
            {
                v: cBg
            }
        ])}
         ${styleGenerator(`.${uniqueId}.wp-block-faqmate-faq .asfa__heading_tag`, [
             {
                 v: tDeskTypo
             },
             {
                 v: tDeskMargin
             },
             {
                 p: ' color',
                 v: titleColor
             }
         ])}
         ${styleGenerator(`.${uniqueId}.wp-block-faqmate-faq .answer`, [
             {
                 v: qDeskTypo
             },
             {
                 v: qDeskMargin
             },
             {
                 p: ' color',
                 v: answerColor
             }
         ])}
          ${styleGenerator(`.${uniqueId}.wp-block-faqmate-faq .faqmate__icon`, [
              {
                  v: iDeskBorder
              },
              {
                  v: iDeskBRadius
              },
              {
                  v: iDeskPadding
              },
              {
                  v: iBg
              },
              {
                  v: iDeskWidth
              },
              {
                  v: iDeskHeight
              }
          ])}
            ${styleGenerator(`.${uniqueId}.wp-block-faqmate-faq .faqmate__icon svg`, [
                {
                    v: iDeskWidth
                },
                {
                    v: iDeskHeight
                }
            ])}
             ${styleGenerator(`.${uniqueId}.wp-block-faqmate-faq .faqmate__icon svg path`, [
                 {
                     p: 'fill',
                     v: iconColor
                 }
             ])}
             ${styleGenerator(`.${uniqueId}.wp-block-faqmate-faq .single-faq .asfa__numbering`, [
                 {
                     p: 'color',
                     v: countColor
                 }
             ])}
       
    `;
    const tabStyles = `
       ${styleGenerator(`.${uniqueId}.wp-block-faqmate-faq .asfa__head`, [
           {
               v: cTabBorder
           },
           {
               v: cTabBRadius
           },
           {
               v: cTabPadding
           },
           {
               v: cTabMargin
           }
       ])}
        ${styleGenerator(`.${uniqueId}.wp-block-faqmate-faq .asfa__heading_tag`, [
            {
                v: tTabTypo
            },
            {
                v: tTabMargin
            }
        ])}
         ${styleGenerator(`.${uniqueId}.wp-block-faqmate-faq .answer`, [
             {
                 v: qTabTypo
             },
             {
                 v: qTabMargin
             }
         ])}
          ${styleGenerator(`.${uniqueId}.wp-block-faqmate-faq .faqmate__icon`, [
              {
                  v: iTabBorder
              },
              {
                  v: iTabBRadius
              },
              {
                  v: iTabPadding
              },
              {
                  v: iTabWidth
              },
              {
                  v: iTabHeight
              }
          ])}
            ${styleGenerator(`.${uniqueId}.wp-block-faqmate-faq .faqmate__icon svg`, [
                {
                    v: iTabWidth
                },
                {
                    v: iTabHeight
                }
            ])}
            

    `;
    const mobStyles = `
        ${styleGenerator(`.${uniqueId}.wp-block-faqmate-faq .asfa__head`, [
            {
                v: cMobBorder
            },
            {
                v: cMobBRadius
            },
            {
                v: cMobPadding
            },
            {
                v: cMobMargin
            }
        ])}
         ${styleGenerator(`.${uniqueId}.wp-block-faqmate-faq .asfa__heading_tag`, [
             {
                 v: tMobTypo
             },
             {
                 v: tMobMargin
             }
         ])}
         ${styleGenerator(`.${uniqueId}.wp-block-faqmate-faq .answer`, [
             {
                 v: qMobTypo
             },
             {
                 v: qMobMargin
             }
         ])}
          ${styleGenerator(`.${uniqueId}.wp-block-faqmate-faq .faqmate__icon`, [
              {
                  v: iMobBorder
              },
              {
                  v: iMobBRadius
              },
              {
                  v: iMobPadding
              },
              {
                  v: iMobWidth
              },
              {
                  v: iMobHeight
              }
          ])}
            ${styleGenerator(`.${uniqueId}.wp-block-faqmate-faq .faqmate__icon svg`, [
                {
                    v: iMobWidth
                },
                {
                    v: iMobHeight
                }
            ])}
    
    `;

    return (
        <GlobalStyleHandler
            attributes={attributes}
            setAttributes={setAttributes}
            deskStyles={deskStyles}
            tabStyles={tabStyles}
            mobStyles={mobStyles}
        />
    );
};

export default DynamicStyle;
